import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog, FlatButton } from 'material-ui';

import { deleteBackendNotification } from 'actions/notifications/backendNotifications';

class DeleteBackendNotification extends React.Component {
    constructor(props) {
        super(props);

        this.delete = this.delete.bind(this);
    }

    delete() {
        this.props.deleteBackendNotification(this.props.deleteId);
        this.props.toggle();
    }

    render() {
        const { open, toggle } = this.props;

        const actions = [
            <FlatButton
                label='Yes'
                onClick={this.delete}
            />,
            <FlatButton
                label='No'
                onClick={toggle}
            />,
        ];

        return (
            <Dialog
                title='Do you want to delete notification?'
                modal={false}
                open={open}
                onRequestClose={toggle}
                actions={actions}
            />
        );
    }
}

export default connect(
    (state, props) => {
        return {

        };
    },
    dispatch => bindActionCreators({ deleteBackendNotification }, dispatch),
)(DeleteBackendNotification);



// WEBPACK FOOTER //
// ./app/components/BackendNotifications/Delete.jsx